import { GetSinglePluginResponse } from "src/api/generated/frontend_internal_v1";
import React from "react";

/** Data provided by the {@link SINGLE_PLUGIN_CONTEXT} */
export type SinglePluginContext = {
    /** The currently available plugin */
    plugin: GetSinglePluginResponse;

    /** Reload the plugin's information */
    reset: () => Promise<void>;
};

/** {@link React.Context} to access the groups */
const SINGLE_PLUGIN_CONTEXT = React.createContext<SinglePluginContext>({
    plugin: {
        description: "",
        image: "",
        installed: false,
        name: "",
        outdated: false,
        uuid: "",
        version: "",
        rulesets: [],
    },

    /**
     * Reset the plugin
     *
     * @returns a resolved promise
     */
    reset: () => Promise.resolve(),
});
SINGLE_PLUGIN_CONTEXT.displayName = "SinglePlugin";
export default SINGLE_PLUGIN_CONTEXT;
